function gvAddVehicle() {
  if (typeof MMY_Customer === "undefined" || MMY_Customer == "") {
    document.location = "/account/login?return_url=%2Fpages%2Fmy-garage";
  }

  var make = document.querySelector("#gv-mmy .mmy-make .mk").value;
  var model = document.querySelector("#gv-mmy .mmy-model .md").value;
  var year = document.querySelector("#gv-mmy .mmy-year .yr").value;
  if (make != "" && (model != "") & (year != "")) {
    var vehicle = new Object();
    vehicle.make = make;
    vehicle.model = model;
    vehicle.year = year;
    gvCreateCookie(MMY.jsonVehicleCookie, vehicle);
  }
  vehicleObect = (readCookie(MMY.jsonVehicleCookie) || { mmy: "" }).mmy;
  var vehicleJSONString = JSON.stringify(vehicleObect);
  console.log(vehicleJSONString);

  if (!(make != "" && model != "" && year != "")) {
    window.alert(selectVehicleLabel);
    return;
  }

  var cookie = readCookie(MMY.cookie);

  var alreadySaved = checkVehicleInGarage();
  //var jsonVehicles;
  //var alreadySaved = false;
  // check if vehicle is already saved
  // try {
  //  jsonVehicles = JSON.parse(vehicles);

  //  for (var i = 0; i < jsonVehicles.length; i++) {
  //   if (
  //   jsonVehicles[i].make == vehicleObect.make &&
  //   jsonVehicles[i].model == vehicleObect.model &&
  //   jsonVehicles[i].year == vehicleObect.year
  // ) {
  //   alreadySaved = true;
  //   break;
  //  }
  //  }
  // } catch (e) {}

  // if already saved, throw alert
  if (alreadySaved) {
    window.alert("Item already saved in list");
    return;
  }

  // proceed with saving vehicle
  $.post(
    MMY.rootUrl + "/Shopify/SaveModel",
    { customerid: cookie.customer, model: vehicleJSONString },
    function (d) {
      if (d.status == "error") alert(d.err);
      else if (d.status == "success" && d.err == "Anon") {
        MMY.RenderVehiclesList(d.vehicles);
      } else if (d.status == "success" && d.err == "Customer") {
        MMY.RenderVehiclesList(FormatVehicleForJSON(d.vehicles));
        addedToGarageNotifucation();
        // update current vehcles object
        vehicles = FormatVehicleForJSON(d.vehicles);
        //document.location = "/pages/my-garage";
      }
    }
  );
}

function addedToGarageNotifucation() {
  var addToGarageButton = document.getElementById("addtoMyGarageButton");

  // Store the original button text and styles
  var originalText = addToGarageButton.innerText;
  var originalBackgroundColor = addToGarageButton.style.backgroundColor;
  var originalColor = addToGarageButton.style.color;

  // Change the text and styles
  addToGarageButton.innerText = "Added to garage";
  addToGarageButton.style.backgroundColor = "green";
  addToGarageButton.style.color = "white"; // Optional: change text color to white for contrast

  // Revert the changes after 5 seconds (5000 milliseconds)
  setTimeout(function () {
    addToGarageButton.innerText = originalText;
    addToGarageButton.style.backgroundColor = originalBackgroundColor;
    addToGarageButton.style.color = originalColor;
  }, 5000); //5-second delay
}

// This function is for checking if the vehicle is save in garage
function checkVehicleInGarage() {
  var jsonVehicles;
  var alreadySaved = false;

  // check if vehicle is already saved
  try {
    jsonVehicles = JSON.parse(vehicles);

    for (var i = 0; i < jsonVehicles.length; i++) {
      if (
        jsonVehicles[i].make == vehicleObect.make &&
        jsonVehicles[i].model == vehicleObect.model &&
        jsonVehicles[i].year == vehicleObect.year
      ) {
        alreadySaved = true;
        break;
      }
    }
  } catch (e) {}

  return alreadySaved;
}

// The function changes the entire list styling that the application provides
function restylingAppElements() {
  const updateTargetNode = document.querySelector("#gv-save-vehicles");
  const vehicleList = updateTargetNode.querySelector("ul");

  if (vehicleList) {
    // changing <li> elems for layout conversion
    const vehicleListItems = vehicleList.querySelectorAll(
      "#gv-save-vehicles ul li"
    );

    // if at least one is added to the list - hide unnecessary elements on the page
    const hiddenClassOnMyEngineElements = (listNotEmpty) => {
      const myEngineBoxWrapper = document.getElementById("my-engine-box-panel");
      if (myEngineBoxWrapper) {
        if (listNotEmpty) {
          myEngineBoxWrapper.classList.add("hide-unnecessary");
        } else {
          myEngineBoxWrapper.classList.remove("hide-unnecessary");
        }
      }
    };

    let listNotEmpty = false;
    vehicleListItems.forEach((listItem) => {
      if (!listItem.classList.contains("add-current-link-wrapper")) {
        listNotEmpty = true;
        return;
      }
    });
    if (vehicleList.childElementCount <= 1) {
      updateTargetNode.querySelector(".popup").classList.add("hidden");
      document.querySelector("#goVediaListTitle").classList.add("hidden");
    } else {
      updateTargetNode.querySelector(".popup").classList.remove("hidden");
      document.querySelector("#goVediaListTitle").classList.remove("hidden");
    }
    if (listNotEmpty) {
      hiddenClassOnMyEngineElements(true);
    } else {
      hiddenClassOnMyEngineElements(false);
    }

    vehicleListItems.forEach((listItem) => {
      // avoid duplication of parameters
      const existingParametersDiv = listItem.querySelector(
        "div.vehicle-parameters"
      );

      if (!existingParametersDiv) {
        // parameter wrapper
        const parametersDiv = document.createElement("div");
        parametersDiv.className = "vehicle-parameters";
        listItem.appendChild(parametersDiv);

        // retrieving json tag with parameters
        const vehicleLink = listItem.querySelector("a.vehicle-link");
        if (vehicleLink) {
          const jsonContent = vehicleLink.getAttribute("json");
          // parameter string to object
          const jsonObject = JSON.parse(jsonContent);
          const jsonKeys = Object.keys(jsonObject);

          // pass through the object and add each one in the form of <p><b>[key]</b><span>[value]</span></p>
          for (const key of jsonKeys) {
            // <p>
            const pElement = document.createElement("p");

            // <b>
            const bElement = document.createElement("b");
            bElement.textContent = `${key}: `;
            pElement.appendChild(bElement);

            // <span>
            const spanElement = document.createElement("span");
            spanElement.textContent = jsonObject[key];
            pElement.appendChild(spanElement);

            parametersDiv.appendChild(pElement);
          }

          // bottom button organization in <li>
          const delVehicleLink = listItem.querySelector("a.gv-del-vehicle"); // delete button
          delVehicleLink.textContent = "Remove from my garage";

          // move the link down and make a button out of it, then for the header duplicate the link and paste it in the beginning
          const titleVehicleLink = listItem.querySelector("a.vehicle-link");
          const titleVehicleLinkClone = titleVehicleLink.cloneNode(true);
          titleVehicleLink.textContent = "Shop Accessories";
          titleVehicleLink.id = "gv-shop-accessories";
          titleVehicleLink.classList.add("btn", "btn--primary");
          titleVehicleLink.classList.remove("vehicle-link");

          // buttons wrapper
          const divButtonsWrapper = document.createElement("div");
          divButtonsWrapper.classList.add(
            "buttons-wrapper",
            "flex",
            "items-center",
            "w-full"
          );

          listItem.prepend(titleVehicleLinkClone);
          divButtonsWrapper.appendChild(titleVehicleLink);
          divButtonsWrapper.appendChild(delVehicleLink);
          listItem.appendChild(divButtonsWrapper);
        }
      }
    });
  }
}
function rootVehicleListObserver() {
  const rootVehicleList = document.querySelector("#gv-save-vehicles ul");
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        restylingAppElements();
      }
    }
  });

  const config = {
    childList: true,
    subtree: true,
    attributes: true,
    characterData: true,
  };

  if (rootVehicleList) {
    observer.observe(rootVehicleList, config);
  }
}
function clearMMYSelectionWithOutPostback() {
  if (MMY_Collection == false || MMY_Tags == "") {
    // Get the clear button by class
    var clearButton = document.querySelector("#gv-mmy .gv-btn-clear");
    clearButton.type = "button";
    clearButton.removeAttribute("disabled");

    var newClearButton = clearButton.cloneNode(true);
    clearButton.parentNode.replaceChild(newClearButton, clearButton);

    // Add a click event listener to the new clear button
    newClearButton.addEventListener("click", function (e) {
      e.preventDefault();
      var firstDropdown = document.querySelector("#gv-mmy select");

      if (firstDropdown) {
        firstDropdown.selectedIndex = 0;
        var event = new Event("change");
        firstDropdown.dispatchEvent(event);
      }
    });
  }
}

const targetNode = document.querySelector("#gv-save-vehicles");

const observer = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      restylingAppElements();
      rootVehicleListObserver();
    }
  }
});

if (targetNode) {
  const config = { childList: true };
  observer.observe(targetNode, config);
}

//Add oberver for gv-mmy to clear MMY Selection WithOut Postback
const gvMMYDiv = document.querySelector("#gv-mmy");

const observerGvMMYDiv = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      clearMMYSelectionWithOutPostback();
    }
  }
});

if (gvMMYDiv) {
  const config = { childList: true };
  observerGvMMYDiv.observe(gvMMYDiv, config);
}

function insertAddtoMyGarageButton() {
  if (checkVehicleInGarage()) {
    return false;
  }
  var addtoMyGarageButton = document.querySelector("#addtoMyGarageButton");
  if (addtoMyGarageButton == null) {
    if (MMY_Tags.length > 0) {
      var goButton = document.querySelector(".gv-btn-search");
      goButton.classList.add("gv-hide");

      var addtoMyGarageButton = document.createElement("button");
      addtoMyGarageButton.id = "addtoMyGarageButton";
      addtoMyGarageButton.textContent = "Add to My Garage";
      addtoMyGarageButton.classList.add("gv-btn-addtogarage");
      addtoMyGarageButton.addEventListener("click", function () {
        gvAddVehicle();
      });

      goButton.parentNode.insertBefore(addtoMyGarageButton, goButton);
    }
  }

  var ddlMake = document.querySelector("#gv-mmy .mmy-make .mk");
  var ddlModel = document.querySelector("#gv-mmy .mmy-model .md");
  var ddlSubModel = document.querySelector("#gv-mmy .mmy-submodel .sm");
  var ddlYear = document.querySelector("#gv-mmy .mmy-year .yr");

  // Add the new 'change' event listeners while preserving existing ones
  addChangeEventToDropdown(ddlMake, showGoButton);
  addChangeEventToDropdown(ddlModel, showGoButton);
  if (ddlSubModel != null) {
    addChangeEventToDropdown(ddlSubModel, showGoButton);
  }
  addChangeEventToDropdown(ddlYear, showGoButton);
}

function addChangeEventToDropdown(dropdown, callback) {
  // Save the existing 'change' event handler, if any
  var existingChangeEvent = dropdown.onchange;

  // Add the new change event listener
  dropdown.addEventListener("change", function (event) {
    // If there was an existing 'change' event handler, call it
    if (typeof existingChangeEvent === "function") {
      existingChangeEvent(event);
    }

    // Call the new callback function
    callback(event);
  });
}

function showGoButton() {
  var addtoMyGarageButton = document.querySelector("#addtoMyGarageButton");
  if (addtoMyGarageButton != null) {
    addtoMyGarageButton.classList.add("gv-hide");
    var goButton = document.querySelector(".gv-btn-search");
    goButton.classList.remove("gv-hide");
  }
}

document.addEventListener("DOMContentLoaded", function () {
  var btnText = "SHOP BY MODEL";

  var autoPartSearchDiv = document.querySelector(".auto-part-search-bar");
  // if MMY is selected, make the autopart search div visible
  if (MMY_Tags.length > 0) {
    if (autoPartSearchDiv.classList.contains("open") == false) {
      autoPartSearchDiv.classList.add("open");
    }
  }

  if (autoPartSearchDiv !== null) {
    //Shop by model mobile button
    var button = document.createElement("button");
    button.id = "apsToggleButton";
    button.textContent = btnText;
    button.classList.add("button");

    autoPartSearchDiv.parentNode.insertBefore(button, autoPartSearchDiv);
    button.addEventListener("click", function () {
      if (autoPartSearchDiv.classList.contains("open")) {
        autoPartSearchDiv.classList.remove("open");
      } else {
        autoPartSearchDiv.classList.add("open");
        //add "Add to My Garage" button
        insertAddtoMyGarageButton();
      }
    });

    //Shop by model desktop button
    var websiteSearchDiv = document.querySelector(".header__search-bar");
    var desktopButton = document.querySelector("#apsToggleButtonDesktop");
    //desktopButton.id = "apsToggleButtonDesktop";
    //desktopButton.textContent = btnText;
    //desktopButton.classList.add("button");
    // websiteSearchDiv.parentNode.insertBefore(
    //   desktopButton,
    //  websiteSearchDiv.nextSibling
    //);
    desktopButton.addEventListener("click", function () {
      if (autoPartSearchDiv.classList.contains("open")) {
        autoPartSearchDiv.classList.remove("open");
      } else {
        autoPartSearchDiv.classList.add("open");
        //add "Add to My Garage" button
        insertAddtoMyGarageButton();
        document.body.scrollTop = document.documentElement.scrollTop = 0;
      }
    });

    desktopButton.classList.remove("disabled");
  }
});

const targetNodeMMY = document.querySelector("#gv-mmy");
const observerMMY = new MutationObserver((mutationsList) => {
  for (let mutation of mutationsList) {
    if (mutation.type === "childList") {
      insertAddtoMyGarageButton();
    }
  }
});

if (targetNodeMMY) {
  const config = { childList: true };
  observerMMY.observe(targetNodeMMY, config);
}

function deleteVehicle(vehicleToDelete) {
  var cookie = readCookie(MMY.cookie);
  // Assuming MMY and cookie are already defined in your context

  fetch(MMY.rootUrl + "/Shopify/DeleteModel", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      customerid: cookie.customer,
      model: vehicleToDelete,
    }),
  })
    .then((response) => response.json())
    .then((d) => {
      if (d.status === "error") {
        alert(d.err);
      } else {
        MMY.vehicles = d.vehicles;

        if (d.status === "success" && d.err === "Anon") {
          MMY.RenderVehicles(d.vehicles);
        } else if (d.status === "success" && d.err === "Customer") {
          //console.log('govedia - remove');
          /*console.log(d.vehicles);*/
          MMY.RenderVehicles(FormatVehicleForJSON(d.vehicles));
          document
            .querySelector(".gv-vehicles")
            .querySelector(".popup")
            .classList.toggle("hidden");
        }
      }
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}
